const IAM_USER_STATUS_ACTIVE = 'active';
const IAM_USER_STATUS_INACTIVE = 'inactive';

module.exports = {
  IAM_USER_STATUS_ACTIVE,
  IAM_USER_STATUS_INACTIVE,
};
